<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ALGzup/tc-custom/9781416982890.jpg?1730494026794" alt="This image is the cover for the book Haunted, Hardy Boys Super Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted, Hardy Boys Super Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>ATAC Briefing for Agents Frank and Joe Hardy:</b><br/><i>Special Paranormal Operation</i><br/><br/><b>MISSION</b>: Investigate possible supernatural disturbances at the Undercliff House of Detention, formerly an insane asylum in the 1800s. <br/><br/><b>LOCATION</b>: Juvenile detention center in Glastonbury, CT. <br/><br/><b>POTENTIAL VICTIMS</b>: Many of the inmates appear to be dying from pure terror! <br/><br/><b>SUSPECTS</b>: Lara Renner claims to be a psychic with a direct line to the spirit behind the hauntings, but perhaps her motives are more down-to-earth. Then there's the cafeteria worker with a major grudge. Or could it be the culprits are truly ghosts?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Franklin W. Dixon
      </h2>
      
      <p class="authorDescription body article"><P> Franklin W.&#160;Dixon is the pen name used by a variety of different authors (Charles Leslie McFarlane, a Canadian author, being the first) who wrote The Hardy Boys novels. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54b703b2